var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0001 4C10.7158 4 4.00008 10.7157 4.00008 19C4.00008 27.2843 10.7158 34 19.0001 34C27.2844 34 34.0001 27.2843 34.0001 19C34.0001 10.7157 27.2844 4 19.0001 4ZM0.666748 19C0.666748 8.87478 8.87486 0.666672 19.0001 0.666672C29.1253 0.666672 37.3334 8.87478 37.3334 19C37.3334 29.1252 29.1253 37.3333 19.0001 37.3333C8.87486 37.3333 0.666748 29.1252 0.666748 19ZM27.6786 12.8215C28.3295 13.4724 28.3295 14.5276 27.6786 15.1785L17.6786 25.1785C17.0277 25.8294 15.9724 25.8294 15.3216 25.1785L10.3216 20.1785C9.6707 19.5276 9.6707 18.4724 10.3216 17.8215C10.9724 17.1706 12.0277 17.1706 12.6786 17.8215L16.5001 21.643L25.3216 12.8215C25.9724 12.1706 27.0277 12.1706 27.6786 12.8215Z",
    fill: "#0DC014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOutline);
export default __webpack_public_path__ + "static/media/tickOutline.2b33b6625dc9aa1321c2f4446081c89a.svg";
export { ForwardRef as ReactComponent };